import { memo as Memo, useState, useEffect, useRef, useCallback } from 'react';
import { useRouter } from 'next/router';
import Cookie from 'js-cookie';
import gsap from 'gsap';

//* HOCs
import { withLanguageContext } from 'context';

//* Components
import Text from 'components/common/Text';
import Button from 'components/common/Button';

//* Styles
import CookiePopupStyle from './style';

const CookiePopup = Memo(({ translate }) => {
	//! States
	const [active, setActive] = useState(false);

	//! Refs
	const popupRef = useRef();

	//! Router
	const router = useRouter();

	//! Did Mount
	useEffect(() => {
		const cpCookie = Cookie.get('cp');

		if (!cpCookie) {
			setActive(true);
		}
	}, []);

	useEffect(() => {
		if (active) {
			gsap.to(popupRef.current, {
				xPercent: -50,
				yPercent: 0,
				x: 0,
				y: 0,
				force3D: true,
				delay: 3,
			});
		}
	}, [active]);

	//! Handle accept click
	const handleAcceptClick = useCallback(() => {
		Cookie.set('cp', true);
		gsap.to(popupRef.current, {
			xPercent: -50,
			yPercent: 200,
		}).then(() => setActive(false));
	}, []);

	return active ? (
		<CookiePopupStyle ref={popupRef}>
			<Text className='cp-text font-helvetica p'>
				{translate('cookiePopupText')}{' '}
				<span
					className='cp-read-more'
					onClick={() => router.push('/privacy-policy')}>
					{` ${translate('readMore')}`}
				</span>
			</Text>

			<Button
				className='cp-button'
				text='acceptAndClose'
				color={'ColorBigStone'}
				borderColor={'ColorApricot'}
				background={'ColorApricot'}
				hoverColor={'ColorWhite'}
				hoverBorderColor={'ColorApricot'}
				hoverBackground={'ColorApricot'}
				onClick={handleAcceptClick}
			/>
		</CookiePopupStyle>
	) : null;
});

// Selected Lang for updating Memo component
export default withLanguageContext(CookiePopup, ['translate', 'selectedLang']);
